module.exports = __webpack_public_path__ + "static/img/bonus_3.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_3.png
// module id = bRyH
// module chunks = 0